/* eslint-disable camelcase */

import { toHex } from '../../../shared/form-lib';

export function whenSideBySide(ctrl, formDesign) {
  if (!ctrl.is_row && formDesign.design.label_orientation === 'side-by-side') {
    return 'side-by-side';
  }
  return '';
}

export function assignFormDesignToCSSVars(inBuilder, formDesign) {
  if (inBuilder) return undefined;
  
  const formDesignCSSVars = {
    '--formFontSize': formDesign.old.form_font_size,
    '--formTextColor': toHex(formDesign.old.form_text_color),
    '--formFontType': formDesign.old.form_font || 'Quicksand',
    '--formFieldColor': toHex(formDesign.design.form_field_color),
    '--formLabelTransform': formDesign.design.form_body_label_transform,
    '--formBodyLabelColor': toHex(formDesign.design.form_body_label_color),
    '--formFieldBorderColor': toHex(formDesign.design.form_field_border_color),
    '--formFieldBackgroundColor': toHex(formDesign.design.form_field_background_color) || '#ffffff',
    '--formFieldBorderRadius':
      formDesign.design.form_field_border_radius >= 0 && `${formDesign.design.form_field_border_radius}px`,
  };

  return formDesignCSSVars;
}

export default { whenSideBySide, assignFormDesignToCSSVars };
